export default __webpack_public_path__ + "static/media/social-discord-icon.cd4605ee.svg";